export default "__VITE_ASSET__Bd88HSqF__"